import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  ACCESSTOKEN_LOCALSTORAGE_KEY,
  LNG_LOCALSTORAGE_KEY,
} from '../const/localstorage.const';

import storage from '../lib/storage';
import { envConfig } from '@/config/env/env.config';
import { getRouteLogin } from '../const/router.const';
import { SharedStoreState } from '../store';

export const request: AxiosInstance = axios.create({
  baseURL: envConfig.API_ROOT,
});

request.defaults.headers.common.Accept = 'application/json';

//todo: some Content-Type is not being set
request.defaults.headers.common['Content-Type'] =
  'application/json; charset=utf-8';

let token = storage.get(ACCESSTOKEN_LOCALSTORAGE_KEY);

export const apiSubscribe = (store?: SharedStoreState): void => {
  if (store?.accessToken) token = store?.accessToken;

  if (token) {
    request.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  const currentLang = store?.lng ?? storage.get(LNG_LOCALSTORAGE_KEY);

  request.defaults.headers.common['Accept-Language'] = currentLang;
};

apiSubscribe();

request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const status = error?.response?.status;
    if (status === 401 && typeof window !== 'undefined') {
      storage.clear();
      window.location.href = getRouteLogin();
    } else if (status === 429) {
      alert('messages.Too Many Requests');
    } else if (status === 503) {
      // window.location.href = authRoutes.MAINTENANCE;
    }
    return Promise.reject(error);
  },
);
